import type { UIVariant } from './types'

export const UI_VARIANT_ATTRIBUTE = 'data-ui-variant'

/** The attribute is the scope every next-only token and style hangs from. */
export function applyUIVariantAttribute(variant: UIVariant): void {
  const root = document.documentElement
  if (variant === 'next') {
    root.setAttribute(UI_VARIANT_ATTRIBUTE, 'next')
  } else {
    root.removeAttribute(UI_VARIANT_ATTRIBUTE)
  }
}
